import { render, staticRenderFns } from "./SoftClTable.vue?vue&type=template&id=f04a42c8&scoped=true&"
import script from "./SoftClTable.vue?vue&type=script&lang=js&"
export * from "./SoftClTable.vue?vue&type=script&lang=js&"
import style0 from "./SoftClTable.vue?vue&type=style&index=0&id=f04a42c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f04a42c8",
  null
  
)

export default component.exports